import { render } from "./FattureClientiSottoProgetto.vue?vue&type=template&id=dce348b2&scoped=true&ts=true"
import script from "./FattureClientiSottoProgetto.vue?vue&type=script&lang=ts"
export * from "./FattureClientiSottoProgetto.vue?vue&type=script&lang=ts"

import "./FattureClientiSottoProgetto.vue?vue&type=style&index=0&id=dce348b2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dce348b2"]])

export default __exports__